import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/link-in-bio/LinkInBioClient.tsx");
